import { render } from "./article.vue?vue&type=template&id=595cae74&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"

import "./article.vue?vue&type=style&index=0&id=595cae74&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595cae74"]])

export default __exports__